/* import store from "@user-center/store";
import Bus from "@user-center/Bus"; */
import { getAllMenu, getRoleMenu } from "@user-center/api/user";
import type { ResponeMenuData } from "@user-center/api/user";
import router, { baseRoutes,mallRoutesData } from "@user-center/router";
import { get } from "lodash-es";
import settings from "@user-center/settings";
import store from "@user-center/store";
import type { MenuType ,UserStateType} from "@user-center/store/modules/user";

import { filterRoute } from "./index";
import type { RouteConf } from "./index";
import { findIndex } from "lodash-es";
import {
  toTree,
  filterRoleMenu,
  initFixedRoutesAndTreeMenuData,
} from "./menu"; 
import type { TreeNodeType } from "./menu";

function getTokenKey(): string {
  return settings.tokenKey;
}

function getBrowserStorage(): Storage | null {
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }
  if (typeof localStorage !== "undefined") {
    return localStorage;
  }
  return null;
}

export function getToken(): string | null {
  return getBrowserStorage()?.getItem(getTokenKey()) || null;
}

export function setToken(token: string): void {
  getBrowserStorage()?.setItem(getTokenKey(), token);
}

export function removeToken(): void {
  getBrowserStorage()?.removeItem(getTokenKey());
}
export function isErpBuyMode() {
  return !!getBrowserStorage()?.getItem("batchBindMallOrder");
}

function normalizeMenuList(data: unknown): TreeNodeType[] {
  return Array.isArray(data) ? (data as TreeNodeType[]) : [];
}
/*
function getInfoCheck() {
  setTimeout(function() {
    store.dispatch("user/getInfo").then(res => {
      if (location.hash.indexOf("#/login") >= 0) {
        Bus.$emit("goToByUrl", "/");
      }
    });
  }, 1000);
}
 */
export function bindTekenChange(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.addEventListener("storage", () => {
    // let nowToken = localStorage.getItem(TokenKey);
    // if (event.key === TokenKey) {
    //   if (event.newValue === event.oldValue) {
    //   } else {
    //     console.log("当前token已经发生变化");
    //     if (event.newValue) {
    //       localStorage.setItem(TokenKey, event.newValue);
    //       store.commit("user/SET_TOKEN", event.newValue);
    //       getInfoCheck();
    //     } else {
    //       getInfoCheck();
    //     }
    //   }
    // }
  });
}
export function clearRoutes(): void {
  router.removeRoute("Wrap");
  router.addRoute(baseRoutes);
}
export interface InitAppCallBack {
  (): void;
}
// 根据角色菜单设置前端routes和左侧菜单的方法
export function InitRoutesAndTreeMenuData(
  routePages: RouteConf[],
  initApp: InitAppCallBack
): void {
  store
    .dispatch("user/getInfo")
    .then((rolesResponse: any) => {
     
      const rolesIds: string[] = rolesResponse.roles.map(
        (o: { id: string }) => o.id
      );
      getAllMenu().then((resAllMenu: ResponeMenuData) => {
        const allMenuList = normalizeMenuList(resAllMenu?.data);
        const treeMenu: TreeNodeType[] = toTree(
          allMenuList
        ) as TreeNodeType[];
        getRoleMenu(rolesIds)
          .then((resRoleMenu: ResponeMenuData) => {
            let roleMenuList = normalizeMenuList(resRoleMenu?.data);
            // 判断如果是独立站角色，去除集运菜单
            if (rolesIds.includes('1210247259685564416')) {
              const excludeMenuIds = ['893891978691506176', '893892788682911744']
              roleMenuList = roleMenuList.filter(item => !(excludeMenuIds.includes(String(item.id)) || excludeMenuIds.includes(String(item.parentId))))
            }
            const fixedMenu: TreeNodeType[] =
              initFixedRoutesAndTreeMenuData(baseRoutes);
            const roleMenuMap: Record<string, TreeNodeType> = {};
            roleMenuList.map((o: TreeNodeType) => {
              roleMenuMap[o.id] = o;
            });
            store.commit("user/SET_ALL_MENUS", allMenuList);
            store.commit("user/SET_ROLE_MENUS", roleMenuList);

            // console.log(routePages, resAllMenu, resRoleMenu, "----111-----");
            const pagesCodeMap: Record<string, TreeNodeType> = {};
            let roleTreeMenu: TreeNodeType[] = filterRoleMenu(
              treeMenu,
              roleMenuMap,
              pagesCodeMap
            );
         
            if (roleTreeMenu.length==1&&roleTreeMenu[0].children&&roleTreeMenu[0].children.length>1) {
              roleTreeMenu=roleTreeMenu[0].children;
            }

            // pageRouteCodeMap 前端和后台对应起来的路由code及描述信息索引
            const pageRouteCodeMap: Record<string, TreeNodeType> = {};
            // addRoutes 通过后台权限验证的前端路由
            const addRoutes: RouteConf[] = filterRoute(
              routePages,
              pagesCodeMap,
              pageRouteCodeMap
            );
            // 最终角色和前端route要展现的菜单
            let roleAndRouteTreeMenu: TreeNodeType[] = filterRoleMenu(
              roleTreeMenu,
              pageRouteCodeMap
            );
            mallRoutesData.map((o: RouteConf) => {
              router.addRoute("Wrap", o);
            });
            addRoutes.map((o: RouteConf) => {
              router.addRoute("Wrap", o);
            });
            roleAndRouteTreeMenu = roleAndRouteTreeMenu.concat(fixedMenu);
            // 菜单排序
            roleAndRouteTreeMenu = roleAndRouteTreeMenu.sort(
              (last: any, next: any) => {
                const lastLevel = last.sequence !== null ? last.sequence : 0;
                const nextLevel = next.sequence !== null ? next.sequence : 0;
                return lastLevel - nextLevel;
              }
            );
            roleAndRouteTreeMenu.forEach((item: any) => {
              if (item.children) {
                item.children = item.children.sort((last: any, next: any) => {
                  const lastLevel = last.sequence !== null ? last.sequence : 0;
                  const nextLevel = next.sequence !== null ? next.sequence : 0;
                  return lastLevel - nextLevel;
                });
                item.children.forEach((levelItem: any) => {
                  if (levelItem.children) {
                    levelItem.children = levelItem.children.sort(
                      (levelLast: any, levelNext: any) => {
                        const levelLastLevel =
                          levelLast.sequence !== null ? levelLast.sequence : 0;
                        const levelNextLevel =
                          levelNext.sequence !== null ? levelNext.sequence : 0;
                        return levelLastLevel - levelNextLevel;
                      }
                    );
                  }
                });
              }
            });
            let roleAndRouteMenus: TreeNodeType[] = [];
            if (roleAndRouteTreeMenu[0] && roleAndRouteTreeMenu[0].level === 0) {
              roleAndRouteMenus = roleAndRouteTreeMenu[0]
                ? (roleAndRouteTreeMenu[0].children as TreeNodeType[])
                : [];
            } else {
              roleAndRouteMenus = roleAndRouteTreeMenu;
            }
            store.commit("user/SET_ROLE_AND_ROUTE_MENUS", roleAndRouteMenus);
            store.dispatch("user/getMenuTipMap")
            initApp();
            // resRoleMenu.
          })
          .catch(() => {
            removeToken();
            initApp();
          });
      });
    })
    .catch((e: Error): void => {
      console.log(e);
      removeToken();
      initApp();
    });
}

export function isErpUser(user:UserStateType):boolean{
  let res = false;
  if ( user &&  user.id) {
    let findIdx = findIndex(
      user.roles || [],
      (o: any) => o.code == "TMS_MEMBER"
    );
    if (findIdx >= 0) {
      res = true;
    }
  }
  return res;
}
